/**
 * Plan `frontend_code` is often wrapped in an outer Tailwind "card shell" (border + rounded + bg-white)
 * that duplicates the host page frame. Strip that single outer div when present so layout matches
 * the app shell and avoids nested white boxes.
 */
export function stripFrontendCodeOuterCard(html) {
    if (!html || typeof html !== 'string') return html;
    const t = html.trim();
    if (/^<!doctype|^<html/i.test(t)) return html;

    const openRe = /^<div\b([^>]*)>/i;
    const openMatch = t.match(openRe);
    if (!openMatch) return html;

    const attrs = openMatch[1];
    const classMatch = attrs.match(/\bclass\s*=\s*(["'])([^"']*)\1/i);
    const cls = classMatch ? classMatch[2] : '';
    const tokens = cls.split(/\s+/).filter(Boolean);
    const hasBorder = tokens.includes('border');
    const hasRounded = tokens.some((c) => c.startsWith('rounded'));
    const hasWhiteBg = tokens.includes('bg-white');
    if (!(hasBorder && hasRounded && hasWhiteBg)) return html;

    const innerStart = openMatch[0].length;
    let depth = 1;
    let i = innerStart;
    const lower = t.toLowerCase();
    while (i < t.length && depth > 0) {
        const nextOpen = lower.indexOf('<div', i);
        const nextClose = lower.indexOf('</div>', i);
        if (nextClose === -1) return html;
        if (nextOpen !== -1 && nextOpen < nextClose) {
            depth += 1;
            i = nextOpen + 4;
        } else {
            depth -= 1;
            if (depth === 0) {
                const inner = t.slice(innerStart, nextClose).trim();
                const after = t.slice(nextClose + 6).trim();
                if (after) return html;
                return inner || html;
            }
            i = nextClose + 6;
        }
    }
    return html;
}
